// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32O1m","buttons":"styles_buttons__367Bi"};